import * as React from 'react';
import { detect } from 'detect-browser';
import * as semver from 'semver';

export const minimumBrowserVersions = [
		{
			name: 'safari',
			minVersion: '11.0.0'
		}
	];

export const checkForMinimumVersion = () => {
	const browser = detect();

	minimumBrowserVersions.forEach((element) => {
		if (browser.name === element.name && semver.lt(browser.version, element.minVersion)) {
			window.location.replace("/updatebrowser");
		}
	});
};

export default class BrowserVersion extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className={'container am_browserversion'}>
				Selaimesi ei ole tuettu. Päivitä laitteesi selain ja käyttöjärjestelmä uusimpiin saatavilla olevaan versioon.
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Common/browserVersion.tsx